import { render, staticRenderFns } from "./ListarCargaRefis.vue?vue&type=template&id=48933d1f&"
import script from "./ListarCargaRefis.vue?vue&type=script&lang=js&"
export * from "./ListarCargaRefis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports